<a class="skip-link" href="#main-content">Skip to main content</a>

<div class="topbar">
  <div class="topbar__inner">
    <div class="topbar__socials">
      <a href="#" aria-label="Facebook">
        <img src="assets/icons/icon-facebook-top.svg" alt="" width="27" height="27" />
      </a>
      <a href="#" aria-label="X">
        <img src="assets/icons/icon-twitter-top.svg" alt="" width="27" height="27" />
      </a>
      <a href="#" aria-label="Instagram">
        <img src="assets/icons/icon-instagram-top.svg" alt="" width="27" height="27" />
      </a>
    </div>
    <p class="topbar__promo">Free shipping on all U.S Under $50+</p>
    <div class="topbar__meta"></div>
  </div>
</div>

<header class="header">
  <div class="header__inner">
    <button
      class="header__menu-btn"
      type="button"
      aria-label="Open menu"
      [attr.aria-expanded]="mobileNavOpen()"
      (click)="toggleMobileNav()"
    >
      <span></span><span></span><span></span>
    </button>

    <div class="header__left">
      <form class="search" role="search" (submit)="onSearch($event)">
        <img src="assets/icons/icon-search.svg" alt="" width="27" height="27" />
        <input
          type="search"
          name="q"
          placeholder="Search your soap"
          aria-label="Search your soap"
          [value]="searchQuery()"
          (input)="searchQuery.set($any($event.target).value)"
        />
      </form>
      <nav class="nav nav--left" aria-label="Primary">
        <a routerLink="/" routerLinkActive="nav__link--active" [routerLinkActiveOptions]="{ exact: true }" class="nav__link">Home</a>
        <div class="nav__item">
          <a routerLink="/all-products" class="nav__link" [class.nav__link--active]="shopActive()">Shop</a>
          <div class="nav__dropdown" role="menu">
            <a routerLink="/all-products" class="nav__dropdown-link" (click)="closeMenus()">All Products</a>
            @if (featuredCatalogs().length > 0) {
              <p class="nav__dropdown-heading">Featured</p>
              @for (product of featuredCatalogs(); track product.id) {
                <a
                  class="nav__dropdown-link"
                  [routerLink]="['/products', featuredCatalogSlug(product)]"
                  (click)="closeMenus()"
                >
                  {{ product.name }}
                </a>
              }
            }
            @for (category of menuCategories(); track category.id) {
              <p class="nav__dropdown-heading">{{ category.name }}</p>
              @if (megamenuCatalogs(category).length === 0) {
                <p class="nav__dropdown-empty">No products in this category yet.</p>
              }
              @for (catalog of megamenuCatalogs(category); track catalog.id) {
                @if (catalog.slug) {
                  <a class="nav__dropdown-link" [routerLink]="['/products', catalog.slug]" (click)="closeMenus()">
                    {{ catalog.name }}
                  </a>
                } @else {
                  <span class="nav__dropdown-link">{{ catalog.name }}</span>
                }
              }
            }
            @if (!menuLoading() && menuCategories().length === 0 && featuredCatalogs().length === 0) {
              <p class="nav__dropdown-empty">No featured products yet.</p>
            }
          </div>
        </div>
        <a routerLink="/where-to-buy" routerLinkActive="nav__link--active" class="nav__link">Store Locator</a>
        <a routerLink="/about" routerLinkActive="nav__link--active" class="nav__link">About</a>
      </nav>
    </div>

    <a routerLink="/" class="logo" aria-label="Hub of Naturals home">
      <img src="assets/images/logo.png" alt="" width="77" height="74" />
      <span>HUB OF NATURALS</span>
    </a>

    <div class="header__right">
      <nav class="nav nav--right" aria-label="Secondary">
        <a routerLink="/faq" routerLinkActive="nav__link--active" class="nav__link">FAQ</a>
        <a routerLink="/blog" routerLinkActive="nav__link--active" class="nav__link">Blog</a>
        <a routerLink="/youtube-testimonials" routerLinkActive="nav__link--active" class="nav__link">Testimonials</a>
        <a routerLink="/contact" routerLinkActive="nav__link--active" class="nav__link">Contact</a>
      </nav>
      <div class="header__actions">
        <div class="header__account-holder" [class.is-open]="openDropdown() === 'account'">
          @if (authService.isAuthenticated()) {
            <button
              type="button"
              class="header__action header__action--account"
              title="My Account"
              aria-haspopup="true"
              [attr.aria-expanded]="openDropdown() === 'account'"
              (click)="toggleDropdown($event, 'account')"
            >
              <img src="assets/icons/icon-profile.svg" alt="" width="37" height="37" />
              <strong class="header__account-name">{{ displayName() }}</strong>
              <svg class="header__account-chevron" width="13" height="8" viewBox="0 0 13 8" fill="none" aria-hidden="true">
                <path d="M1 1.5L6.5 6.5L12 1.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </button>
            <div class="header__account-menu">
              <a routerLink="/account/profile" (click)="closeMenus()">Profile</a>
              <a routerLink="/wishlist" (click)="closeMenus()">Wishlist</a>
              @if (authService.isAffiliate()) {
                <a routerLink="/account/affiliate" (click)="closeMenus()">Affiliate</a>
              }
              @if (authService.isCustomer()) {
                <a routerLink="/account/orders" (click)="closeMenus()">Orders</a>
                <a routerLink="/account/subscriptions" (click)="closeMenus()">Subscriptions</a>
                <a routerLink="/account/payment-method" (click)="closeMenus()">Payment method</a>
              }
              <a routerLink="/account/coupons" (click)="closeMenus()">Coupons</a>
              <a routerLink="/account/wallet" (click)="closeMenus()">Wallet</a>
              <a href="#" (click)="onSignOut($event)">Sign out</a>
            </div>
          } @else {
            <a routerLink="/login" queryParamsHandling="preserve" class="header__action header__action--login">
              <img src="assets/icons/icon-profile.svg" alt="" width="37" height="37" />
              <b class="header__auth-text">Log in</b>
            </a>
            <b class="header__auth-split" aria-hidden="true">/</b>
            <a routerLink="/signup" queryParamsHandling="preserve" class="header__auth-signup">Sign Up</a>
          }
        </div>
        <a href="#" class="header__action header__action--cart" (click)="onBagClick($event)">
          <img src="assets/icons/icon-cart.svg" alt="" width="37" height="37" />
          <span>My Bag</span>
          @if (cartService.itemCount() > 0) {
            <b class="header__cart-count">{{ cartService.itemCount() }}</b>
          }
        </a>
      </div>
    </div>
  </div>

  <div class="mobile-nav" [class.is-open]="mobileNavOpen()">
    <a routerLink="/" (click)="closeMenus()">Home</a>
    <a routerLink="/all-products" (click)="closeMenus()">Shop</a>
    @for (category of menuCategories(); track category.id) {
      <a class="mobile-nav__sub" routerLink="/all-products" (click)="closeMenus()">{{ category.name }}</a>
    }
    <a routerLink="/where-to-buy" (click)="closeMenus()">Store Locator</a>
    <a routerLink="/about" (click)="closeMenus()">About</a>
    <a routerLink="/faq" (click)="closeMenus()">FAQ</a>
    <a routerLink="/blog" (click)="closeMenus()">Blog</a>
    <a routerLink="/youtube-testimonials" (click)="closeMenus()">Testimonials</a>
    <a routerLink="/contact" (click)="closeMenus()">Contact</a>
    @if (authService.isAuthenticated()) {
      <a routerLink="/account/profile" (click)="closeMenus()">Profile</a>
      <a routerLink="/wishlist" (click)="closeMenus()">Wishlist</a>
      @if (authService.isAffiliate()) {
        <a routerLink="/account/affiliate" (click)="closeMenus()">Affiliate</a>
      }
      @if (authService.isCustomer()) {
        <a routerLink="/account/orders" (click)="closeMenus()">Orders</a>
        <a routerLink="/account/subscriptions" (click)="closeMenus()">Subscriptions</a>
        <a routerLink="/account/payment-method" (click)="closeMenus()">Payment method</a>
      }
      <a routerLink="/account/coupons" (click)="closeMenus()">Coupons</a>
      <a routerLink="/account/wallet" (click)="closeMenus()">Wallet</a>
      <a href="#" (click)="onSignOut($event)">Sign out</a>
    } @else {
      <a routerLink="/login" queryParamsHandling="preserve" (click)="closeMenus()">Log in</a>
      <a routerLink="/signup" queryParamsHandling="preserve" (click)="closeMenus()">Sign Up</a>
    }
    <a href="#" (click)="onBagClick($event)">My Bag</a>
  </div>
</header>
